import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { donorapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchDataViewSuccess = (dataview: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: dataview,
});
export const fetchAttachDataSuccess = (attachdataview: any) => ({
    type: 'FETCH_ATTAC_VIEW_DATA_SUCCESS',
    payload: attachdataview,
});
export const fetchDataattachViewSuccess = (attachdata: any) => ({
    type: 'FETCH_VIEW_ATTACH_DATA_SUCCESS',
    payload: attachdata,
});

export const fetchData = (Id:any,needid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {"need":Id,needid:needid};
            const apiname = donorapi.dneedprofile;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const viewdata = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {"need":Id};
            const apiname = donorapi.dviewtable;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


export const viewattachmentdata = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {"need":Id,q:3};
            const apiname = donorapi.dneedprofile;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchAttachDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const viewdataattach = (uid:any,Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid,needid:Id};
            const apiname = donorapi.dview;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataattachViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};